import { Popover, Transition } from "@headlessui/react";
import {
  UserCircleIcon,
  ChatBubbleBottomCenterTextIcon,
  HeartIcon,
  HomeIcon,
  ArrowRightOnRectangleIcon,
  NoSymbolIcon,
  LifebuoyIcon,
  ArrowTopRightOnSquareIcon,
} from "@heroicons/react/24/outline";
import { Fragment } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../redux/reducers/userReducer";
import Avatar from "shared/Avatar/Avatar";
import api from '../../api';

const solutionsFoot = [
  {
    name: "Logout",
    href: "##",
    icon: ArrowRightOnRectangleIcon,
    action: 'logout',
  },
];

const AvatarDropdown = ({ user }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const isAgencyUser = user?.company?.type === 'agencies' || 
                       user?.affiliation?.entity === 'agencies';
  const solutions = [
    ...(isAgencyUser ? [{
      name: "View Agency Profile",
      href: user.company ? `/agency/${user.company.shortname}` : "#",
      icon: ArrowTopRightOnSquareIcon,
      target : "_blank"
    }] : []),
    {
      name: "Account",
      href: "/account",
      icon: UserCircleIcon,
    },
    ...(isAgencyUser ? [
      {
        name: "Favorites",
        href: "/favorites",
        icon: HeartIcon,
      },
      {
        name: "Blacklist",
        href: "/blacklist",
        icon: NoSymbolIcon,
      },
    ] : []),
  ];

  const handleItemClick = (item, closeDropdown) => {
    if(item.action && item.action == 'logout') {
      closeDropdown();
      setTimeout(() => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('company_type');
        dispatch(logout());
        window.location.href = '/login';
      }, 100);
      
      return;
    }
    closeDropdown();
  }
  if (!user || !user.id) {
    return null;
  }

  return (
    <div className="AvatarDropdown">
      <Popover className="relative">
        {({ open, close: closeDropdown }) => (
          <>
            <Popover.Button
              className={`inline-flex items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
            >
              <Avatar imgUrl={user?.avatar ? `${api.getUploadUrl()}/${user.avatar}` : null}
                userName={user?.name || " "}  
                sizeClass="w-8 h-8 sm:w-9 sm:h-9" 
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-[260px] px-4 mt-4 -right-10 sm:right-0 sm:px-0">
                <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
                  {
                    (user?.company && user?.company?.is_confirmed) ?
                    <>
                      <div className="relative grid gap-6 bg-white dark:bg-neutral-800 p-7">
                        {solutions.map((item, index) => (
                          <Link
                            key={index}
                            to={item.href}
                            target={item?.target ? item.target : ""}
                            className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                            onClick={() => closeDropdown()}
                          >
                            <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                              <item.icon aria-hidden="true" className="w-6 h-6" />
                            </div>
                            <div className="ml-4">
                              <p className="text-sm font-medium ">{item.name}</p>
                            </div>
                          </Link>
                        ))}
                      </div>
                      <hr className="h-[1px] border-t border-neutral-300 dark:border-neutral-700" />
                    </>
                    : <></>
                  }
                  <div className="relative grid gap-6 bg-white dark:bg-neutral-800 p-7">
                    {solutionsFoot.map((item, index) => (
                      <Link
                        key={index}
                        to={null}
                        onClick={() => handleItemClick(item, closeDropdown)}
                        className="flex items-center p-2 -m-3 transition duration-150 ease-in-out rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <div className="flex items-center justify-center flex-shrink-0 text-neutral-500 dark:text-neutral-300">
                          <item.icon aria-hidden="true" className="w-6 h-6" />
                        </div>
                        <div className="ml-4">
                          <p className="text-sm font-medium ">{item.name}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { logout })(
  AvatarDropdown
);
